import { render } from "./GuiDisplay.vue?vue&type=template&id=dae4294e&scoped=true"
const script = {}

import "./GuiDisplay.vue?vue&type=style&index=0&id=dae4294e&lang=scss&scoped=true"

import exportComponent from "/Users/iti/Documents/icandy_website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dae4294e"]])

export default __exports__